import { render } from "./OrgEditProfile.vue?vue&type=template&id=53d7e338&scoped=true"
import script from "./OrgEditProfile.vue?vue&type=script&lang=js"
export * from "./OrgEditProfile.vue?vue&type=script&lang=js"

import "./OrgEditProfile.vue?vue&type=style&index=0&id=53d7e338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d7e338"]])

export default __exports__